import { Reducer } from 'redux';

import { ILogin, ILoginDesktop, ILoginFailed, ILogout, ISetLogin, ISetMessage, ISetResorts, TUser } from '../actions';
import { getBearerToken, removeBearerToken } from '../infra';

export interface IUserState {
  loggedIn: boolean;
  rememberUser: boolean;
  message?: string;
}
export const defaultUserState = {
  loggedIn: Boolean(getBearerToken()),
  rememberUser: false,
};

export const userReducer: Reducer<IUserState> = (
  state: IUserState = defaultUserState,
  action: ILogout | ISetLogin | ISetMessage | ISetResorts | ILogin | ILoginDesktop | ILoginFailed
): IUserState => {
  switch (action.type) {
    case TUser.LOGIN_FAILED:
      return { ...state, message: 'Error setting bid ' + action.payload };
    case TUser.LOGIN:
      return { ...state, rememberUser: action.payload.rememberMe };
    case TUser.LOGOUT:
      removeBearerToken();
      return { loggedIn: false, message: '', rememberUser: false };
    case TUser.SET_LOGIN:
      return { ...state, loggedIn: true };
    case TUser.SET_MESSAGE:
      if (state.message === action.payload) {
        action.payload += ' ';
      }
      return { ...state, message: action.payload };
  }
  return state;
};
